import { useIntl } from 'react-intl';
import { Loader } from 'sonata-react-components';

import { FloatingSquaresLoader } from '../FloatingSquaresLoader/FloatingSquaresLoader';

import '@/components/common/AudienceInsights/audienceInsights.scss';
import './buyerInsightsLoader.scss';

export function BuyerInsightsLoader() {
  const { formatMessage } = useIntl();

  const loadingSubtitle = formatMessage({
    defaultMessage: 'This may take some time as we process real-time data.',
    id: 'driveToStore.footfallReport.buyerInsights.loading.subtitle'
  });

  return (
    <div className="audienceInsights">
      <div className="audienceInsights__insightsContent buyerInsightsLoader__insightsContent">
        <div className="audienceInsights__figure buyerInsightsLoader__figure">
          <FloatingSquaresLoader />
          <div className="audienceInsights__personaLabel">
            <span className="audienceInsights__personaLabelTitle">
              {formatMessage({
                defaultMessage: 'LOADING TARGET PERSONA',
                id: 'driveToStore.footfallReport.buyerInsights.loading.targetPersonaLabel'
              })}
            </span>
            <p className="audienceInsights__personaName">
              {formatMessage({
                defaultMessage: 'Generating Profile…',
                id: 'driveToStore.footfallReport.buyerInsights.loading.generatingProfile'
              })}
            </p>
          </div>
        </div>
        <div className="buyerInsightsLoader__body">
          <Loader label={loadingSubtitle} type="landing" variant="default">
            <Loader.Title>
              {formatMessage({
                defaultMessage: 'Extracting audience insights…',
                id: 'driveToStore.footfallReport.buyerInsights.loading.extractingInsights'
              })}
            </Loader.Title>
            <Loader.Subtitle>{loadingSubtitle}</Loader.Subtitle>
          </Loader>
        </div>
      </div>

      <div className="audienceInsights__affinitiesContent buyerInsightsLoader__affinitiesContent">
        <Loader label={loadingSubtitle} type="landing" variant="default">
          <Loader.Title>
            {formatMessage({
              defaultMessage: 'Mapping interests and affinities…',
              id: 'driveToStore.footfallReport.buyerInsights.loading.mappingAffinities'
            })}
          </Loader.Title>
          <Loader.Subtitle>{loadingSubtitle}</Loader.Subtitle>
        </Loader>
      </div>
    </div>
  );
}
